import { Outlet } from 'react-router-dom';
import { PerformanceProvider } from './PerformanceContext';

export function PerformanceLayout() {
  return (
    <PerformanceProvider>
      <div data-testid="performance-shell" className="space-y-4 p-6">
        <Outlet />
      </div>
    </PerformanceProvider>
  );
}
